export default __webpack_public_path__ + "static/media/INFO_IS_INFO.7f816e5b.png";